import React, { useState } from 'react';
import Select from 'react-select';

const MyComponent = () => {
  const options = [
    { value: 'apple', label: 'Apple' },
    { value: 'banana', label: 'Banana' },
    { value: 'cherry', label: 'Cherry' },
    { value: 'durian', label: 'Durian' },
    { value: 'elderberry', label: 'Elderberry' },
  ];

  const [selectedOption, setSelectedOption] = useState(null);

  const handleOptionChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  return (
    <div>
      
      <Select
        options={options}
        value={selectedOption}
        onChange={handleOptionChange}
        placeholder="Select an option"
      />
      

      {selectedOption && (
        <div>
          Selected option: {selectedOption.label} ({selectedOption.value})
        </div>
      )}


    </div>
  );
};

export default MyComponent;